import { useMemo } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { FormattedMessage } from 'react-intl';
import { useGetCurrentOrganization } from '@/api/trafikportalen';
import Button from '@/components/core/Button';
import { DocumentHead } from '@/components/core/DocumentHead';
import { Loading } from '@/components/Loading';
import { useStudentNav } from '@/hooks/useStudentNav';
import { isStudentCollectionType } from '@/helpers/collectionTypes';

export const Route = createFileRoute('/$tenantId/_layout/students/')({
  component: Students,
});

function Students() {
  const { data: organization, isLoading } = useGetCurrentOrganization();
  const getStudentNavs = useStudentNav();

  const navItems = useMemo(() => {
    const enabledTypes = (organization?.enabled_collection_types ?? []).filter(
      isStudentCollectionType,
    );
    return getStudentNavs(enabledTypes);
  }, [organization?.enabled_collection_types, getStudentNavs]);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <>
      <DocumentHead
        titleKey="page.students.title"
        descriptionKey="page.students.description"
      />
      <div className="flex grow flex-col items-center justify-center gap-6 p-8">
        <h1 className="text-2xl font-semibold text-text-900">
          <FormattedMessage defaultMessage="Välj elevkategori" />
        </h1>
        <div className="flex flex-wrap justify-center gap-4">
          {navItems.map(({ to, icon, defaultMessage: title }) => (
            <Button
              key={title}
              to={to}
              variant="outline"
              size="xl"
              startIcon={icon}
              className="min-w-48 flex-col gap-3 rounded-xl px-8 py-6"
            >
              {title}
            </Button>
          ))}
        </div>
        {navItems.length === 0 && !isLoading && (
          <p className="text-text-700">
            <FormattedMessage defaultMessage="Inga elevkategorier är aktiverade för din organisation." />
          </p>
        )}
      </div>
    </>
  );
}
